import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFeatureFlagsV2Rpc } from 'pricing-pages-api/__generated__/chirp/com/hubspot/buying/rpc/ProductRpc';
import { getPublicFeatureFlagsV2Rpc } from 'pricing-pages-api/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getChirpEarlyRequest } from '../utils/earlyRequest';

// ******************* Public ***********************
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const GET_PUBLIC_FEATURE_FLAGS = registerQuery({
  fieldName: 'featureFlags',
  args: ['utk', 'browserLocale', 'preferredCountryCode'],
  fetcher({
    utk,
    browserLocale,
    preferredCountryCode
  }) {
    const request = {
      utk,
      browserLocale,
      preferredCountryCode: preferredCountryCode
    };
    return getChirpEarlyRequest({
      details: Object.assign({}, getPublicFeatureFlagsV2Rpc, {
        earlyRequest: true
      }),
      requestObject: {
        request
      },
      fallbackFetcher: () => rpcClientNoAuth.call(getPublicFeatureFlagsV2Rpc, {
        request
      })
    });
  }
});

// ******************* In-App ***********************
const rpcClientAuth = createRpcClientV2({
  hubHttpClient: http
});
export const GET_FEATURE_FLAGS = registerQuery({
  fieldName: 'result',
  args: [],
  fetcher() {
    return getChirpEarlyRequest({
      details: Object.assign({}, getFeatureFlagsV2Rpc, {
        earlyRequest: true
      }),
      requestObject: {
        request: {}
      },
      fallbackFetcher: () => rpcClientAuth.call(getFeatureFlagsV2Rpc, {})
    });
  }
});